import React from 'react';
import { Form, Input, Switch } from 'antd';
import type { FormInstance } from 'antd';
import { EIQFormLabel } from 'common/components/label/form-label';
import { ICitationConfigurationFormValues, ICitationEscalationTierFormValue } from './citation-configuration-form.types';

type EnabledFieldName =
  | 'isResidentFineAmountEnabled'
  | 'isResidentSuspendTransponderInDaysEnabled'
  | 'isVisitorFineAmountEnabled'
  | 'isVisitorSuspendTransponderInDaysEnabled'
  | 'isRevokeDrivingPrivilegesInDaysEnabled';

type ValueFieldName =
  | 'residentFineAmount'
  | 'residentSuspendTransponderInDays'
  | 'visitorFineAmount'
  | 'visitorSuspendTransponderInDays'
  | 'revokeDrivingPrivilegesInDays';

interface CitationPenaltyFieldProps {
  form: FormInstance<ICitationConfigurationFormValues>;
  ruleName: number;
  tierName: number;
  enabledField: EnabledFieldName;
  valueField: ValueFieldName;
  label: string;
  isWarningOnly: boolean;
  step?: number;
}

const CitationPenaltyField = ({
  form,
  ruleName,
  tierName,
  enabledField,
  valueField,
  label,
  isWarningOnly,
  step = 1,
}: CitationPenaltyFieldProps) => {
  const enabledPath = ['rules', ruleName, 'escalationTiers', tierName, enabledField];
  const valuePath = ['rules', ruleName, 'escalationTiers', tierName, valueField];
  const isEnabled = Form.useWatch(enabledPath, form);

  const handleEnabledChange = (enabled: boolean) => {
    if (!enabled) {
      form.setFieldValue(valuePath, null);
    }
  };

  return (
    <div className="resident-section-fields-item">
      <Form.Item name={[tierName, enabledField]} valuePropName="checked">
        <Switch disabled={isWarningOnly} onChange={handleEnabledChange} />
      </Form.Item>

      <Form.Item label={<EIQFormLabel title={label} />} name={[tierName, valueField]}>
        <Input type="number" min={0} step={step} disabled={isWarningOnly || !isEnabled} />
      </Form.Item>
    </div>
  );
};

export default CitationPenaltyField;
